/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__IdInputs */

const en__field__id = /** @type {(inputs: _Field__IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID (internal)`)
};

const de__field__id = /** @type {(inputs: _Field__IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID (intern)`)
};

/**
* | output |
* | --- |
* | "ID (internal)" |
*
* @param {_Field__IdInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field__id = /** @type {((inputs?: _Field__IdInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__IdInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__id(inputs)
	return de__field__id(inputs)
});